import React from 'react';
import PropTypes from 'prop-types';
import styles from './InteractiveWorksheetsFilter.module.less';
import InteractiveWorksheetsTooltip from './InteractiveWorksheetsTooltip';

export default function InteractiveWorksheetsFilter({
  checked,
  selectCallback,
  hasTooltip,
  showTooltip,
}) {
  const classes = ['form', styles.interactiveFilter];
  const checkboxClasses = ['checkbox', styles.checkbox];

  const tooltip = InteractiveWorksheetsTooltip(hasTooltip, showTooltip);

  return (
    <div className={classes.join(' ')}>
      {tooltip}
      <label className={checkboxClasses.join(' ')}>
        <input
          type="checkbox"
          checked={checked}
          onChange={e => selectCallback(e.target.checked)}
        />
        <div className="checkbox" />
      </label>
      <span>Show interactive only</span>
      <div className={styles.questionMark} onClick={showTooltip}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#02B5BA"
            d="M7.02 9.624V8.892C7.02 8.676 7.036 8.496 7.068 8.352C7.1 8.208 7.148 8.08 7.212 7.968C7.276 7.848 7.36 7.736 7.464 7.632C7.576 7.52 7.712 7.388 7.872 7.236C8 7.116 8.128 6.996 8.256 6.876C8.384 6.748 8.5 6.62 8.604 6.492C8.708 6.356 8.792 6.216 8.856 6.072C8.928 5.92 8.964 5.752 8.964 5.568C8.964 5.384 8.928 5.216 8.856 5.064C8.792 4.904 8.704 4.768 8.592 4.656C8.48 4.544 8.344 4.456 8.184 4.392C8.032 4.328 7.868 4.296 7.692 4.296C7.3 4.296 6.98 4.42 6.732 4.668C6.492 4.916 6.348 5.24 6.3 5.64L5.076 5.52C5.18 4.824 5.468 4.28 5.94 3.888C6.42 3.488 7.012 3.288 7.716 3.288C8.052 3.288 8.364 3.34 8.652 3.444C8.948 3.54 9.204 3.684 9.42 3.876C9.636 4.06 9.804 4.292 9.924 4.572C10.052 4.844 10.116 5.156 10.116 5.508C10.116 5.812 10.072 6.08 9.984 6.312C9.896 6.536 9.772 6.748 9.612 6.948L8.892 7.692L8.772 7.8C8.644 7.92 8.54 8.024 8.46 8.112C8.388 8.192 8.328 8.28 8.28 8.376C8.24 8.464 8.212 8.564 8.196 8.676C8.18 8.788 8.172 8.928 8.172 9.096V9.624H7.02ZM6.792 11.28C6.792 11.064 6.868 10.88 7.02 10.728C7.18 10.568 7.368 10.488 7.584 10.488C7.8 10.488 7.984 10.568 8.136 10.728C8.296 10.88 8.376 11.064 8.376 11.28C8.376 11.496 8.296 11.684 8.136 11.844C7.984 11.996 7.8 12.072 7.584 12.072C7.368 12.072 7.18 11.996 7.02 11.844C6.868 11.684 6.792 11.496 6.792 11.28Z"
          />
          <rect
            x="0.5"
            y="0.5"
            width="15"
            height="15"
            rx="7.5"
            stroke="#02B5BA"
          />
        </svg>
      </div>
    </div>
  );
}

InteractiveWorksheetsFilter.propTypes = {
  selectCallback: PropTypes.func,
  checked: PropTypes.bool,
  showTooltip: PropTypes.func,
  hasTooltip: PropTypes.bool,
};
